import { useTranslate } from 'react-admin';
import { Chip } from '@mui/material';

import { VAULTS_NS as NS } from './constants';
import { stateChip } from './helpers';

export const StateChip = ({ state }: { state: string }) => {
  const translate = useTranslate();
  const { labelKey, color } = stateChip(state);
  return (
    <Chip
      size="small"
      variant="outlined"
      color={color}
      label={labelKey ? translate(labelKey) : state}
    />
  );
};

/** Official / Community tag (PRD §14.4). */
export const KindChip = ({ kind }: { kind: string }) => {
  const translate = useTranslate();
  const known = kind === 'OFFICIAL' || kind === 'COMMUNITY';
  return (
    <Chip
      size="small"
      color={kind === 'OFFICIAL' ? 'primary' : 'default'}
      label={known ? translate(`${NS}.kind.${kind}`) : kind}
    />
  );
};
